import { debounce, hide, show } from '../functions.js';


const MOBILE_BREAKPOINT = 992;

export default function GlobalModule(element) {

    let $burger = element.querySelector('.burger');
    let $mobileMenu = element.querySelector('.mobilemenu');
    let $mobileMenuClose = element.querySelector('.mobilemenu__close');

    if ($burger) {
        $burger.addEventListener('click', (event) => {
            event.preventDefault();
            show($mobileMenu);
        });
    }

    if ($mobileMenuClose) {
        $mobileMenuClose.addEventListener('click', (event) => {
            event.preventDefault();
            hide($mobileMenu);
        });
    }

    window.addEventListener('resize', debounce(() => {
        if (window.innerWidth < MOBILE_BREAKPOINT) {
            // hide(element.querySelector('.main__header__right'));
            // show(element.querySelector('.burger'));
        } else {
        }
    }, 100));

    return this;
}

window.modules = window.modules || {}
window.modules.GlobalModule = GlobalModule;
